import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaPhotosphereIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama_photosphere"}/>
}
